<template>
    <v-card>
    <v-container fluid>
    <v-card>
      <!-- Filtros de Búsqueda-->
    <form ref="form"
    
    lazy-validation>
        <v-row class="px-2">
          <v-col cols="12" sm="6" md="3"> <!-- Start Date -->
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                  <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="editedItem.start_dt"
                      label="Fecha Desde"
                      prepend-icon="mdi-calendar-today"
                      :rules="fechaRule"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                  ></v-text-field>
                  </template>
                  <v-date-picker
                  v-model="editedItem.start_dt" 
                  @input="menu = false"
                  ></v-date-picker>
              </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3"> <!-- End Date -->
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
              >
                  <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="editedItem.end_dt"
                      label="Fecha Hasta"
                      prepend-icon="mdi-calendar-today"
                      :rules="fechaRule"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                  ></v-text-field>
                  </template>
                  <v-date-picker
                  v-model="editedItem.end_dt" 
                  @input="menu2 = false"
                  ></v-date-picker>
              </v-menu>
          </v-col>
        <v-col cols="12" sm="6" md="3"> <!-- Oppoint Id-->
            <v-autocomplete v-model="editedItem.ApiPunto"
            :items="oppoint"
            :item-text="'OpPoint_Description'"
            :item-value="'OpPoint_id'"
            label="Centro"
            multiple
            ></v-autocomplete>
         </v-col>
         <v-col cols="12" sm="6" md="3"> <!-- Turning Storage Area-->
            <v-autocomplete v-model="editedItem.TurningStorageArea"
            :items="TurningStorageArea"
            :item-text="'TurningStorageArea_Desc'"
            :item-value="'TurningStorageArea_Desc'"
            label="Almacen"
            multiple
            ></v-autocomplete>
         </v-col>
         <v-col cols="12" sm="6" md="3"> <!-- Boton Buscar-->
            <v-btn :disabled="btn" color="primary" @click="submit">Buscar</v-btn>
          </v-col>
        </v-row>
      </form>
      <v-spacer></v-spacer>
      </v-card>
      </v-container>

      <!-- Grid -->
      <v-container fluid>
        <v-card>
         <v-card-title>
           <v-icon x-large>mdi-clipboard-list-outline</v-icon>Planning Turnos
           <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filtro"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          id="grillaPlanning"
          v-model="selected"
		  :search="search"
          :headers="headers"
          :items="mvm"
          :single-select="singleSelect"
          item-key="RequestProposal_id"
          show-select
          class="elevation-1"
        >
          <template v-slot:top>
            <v-switch
              v-model="singleSelect"
              label="Selección Individual"
              class="pa-3"
            ></v-switch>
          </template>
        </v-data-table>
      </v-card>
      </v-container>

      <v-container fluid class="pt-0">
        <v-card class="py-2 px-2">
      <template>
      <div >
          <v-btn type="button" color="error" @click="dialog1=true" :disabled="this.selected.length == 0">Eliminar</v-btn>
      </div>
      </template>
      </v-card>
      </v-container>
      

      <v-dialog v-model="dialog1" max-width="350">
        <v-card color="blue-grey darken-3" dark>
          <v-card-title class="headline"> ¿Desea borrar turno?</v-card-title>
          <v-card-title>Recuerde que se cerrará la OC.</v-card-title>
          <v-card-actions>
          <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog1=false">Cancelar</v-btn>
              <v-btn color="error" @click="deleteTurn">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
             <p align="right" class="mb-0"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step class="pt-0" :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Buscando Pedidos
                <small>Consultando Turnos del {{this.editedItem.start_dt}} hasta {{this.editedItem.end_dt}}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar" indeterminate size="64" color="primary"></v-progress-circular><br>
                
                </div>
            </v-card>
            </v-stepper-content>
            <div class="text-center">{{this.msj_proceso}}</div>
        </v-stepper>
      </v-dialog>
	  
          <!-- Loading Overlay -->
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
          </v-overlay>
      </v-card>
    </template>
    
    <script>
    import axios from 'axios'
    //import Vue from "vue";

    export default {
      data: () => ({
        search: '',
        search2: '',
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        dialog: false,
        dialog1: false,
        dialog_pass: false,
        dialog_new: false,
        dialog_detail: false,
        valid: true,
        menu: false,
        menu2: false,
        e1: 0,
        btn: false,
        msj_proceso:'',
        progressBar1: false,
        progressBar: false,
        overlay: false,
        step_error1: true,
        step_error2: true,
        step_error3: true,
        step_color1:"primary",
        step_color2:"primary",
        step_color3:"primary",
        singleSelect: false,
        selected: [],


        headers: [
          { text: 'ID Propuesta Pedido', value: 'RequestProposal_id', width: '120px' },
          { text: 'ID Almacen', value: 'TurningStorageArea_id' },
          { text: 'Almacen', value: 'TurningStorageArea_Desc', width: '200px' },
          { text: 'Punto', value: 'OpPoint_id' },
          { text: 'OC', value: 'VendorPurchaseOrder_Num' },
          { text: 'Prov', value: 'Supplier_id' },
          { text: 'R Social', value: 'Supplier_Description', width: '250px' },
          { text: 'Seccion', value: 'Section_Description'},
          { text: 'Fecha Emisión', value: 'RequestProposal_Dt', width: '150px' },
          { text: 'Fecha Entrega', value: 'Reception_Dt', width: '150px'},
          { text: 'Fecha Cierre', value: 'Closing_Dt', width: '150px' },
          { text: 'Observación', value: 'Comment_Txt', width: '250px' },
          { text: 'Fecha de turno', value: 'CDay_id', width: '150px' },
          { text: 'Hora De Turno', value: 'CHour_Description' },
          { text: 'Bultos pedidos', value: 'qty_bu'},
          { text: 'Pallets Pedidos', value: 'qty_pa'},
          { text: 'Cantidad de Referencias', value: 'qty_line'}
        ],
        mvm: [],
        oppoint: [{ OpPoint_id: '', OpPoint_Description: '-Todos' }],
        TurningStorageArea: [{ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' }],
        ApiUserSupplier:[],
        editedIndex: -1,
        editedItem: {
          start_dt: new Date().toISOString().substr(0, 10),
          end_dt: new Date().toISOString().substr(0, 10),
          ApiPunto: '',
          TurningStorageArea: [ '-Todos' ]
        },
        defaultItem: {
          start_dt: new Date().toISOString().substr(0, 10),
          end_dt: new Date().toISOString().substr(0, 10),
          ApiPunto: '',
          TurningStorageArea: ['-Todos' ]
        },
        fechaRule: [
            v => !!v || 'Fecha es requerida'
        ],
        puntoRules: [
            v => !!v || 'Centro es Requerida',
            v => (v && v != -1.0) || 'Centro no Valida'
        ],
        TurningStorageAreaRules: [
            v => !!v || 'Almacen es Requerido',
            v => (v && v != -1.0) || 'Almacen no Valido'
        ],
        config: {
          headers: {
            //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
            "api-user": sessionStorage.getItem('ApiUser_id')
          }
        }
      }),
    
      watch: {
        dialog (val) {
          val || this.close()
        }
      },
    
      created () {
        this.initialize()
      },
    
      methods: {
        initialize() {
		this.overlay = true

        
         axios.post(this.api_tool_url + '/get_ApiUserSupplier', {ApiUser_id:this.$store.state.ApiUser_id}, this.config)
             .then(response => { 
                 response.data.ResultRows.forEach(info => {
                 this.ApiUserSupplier.push(info.MotherSupplier_Desc)
                 })
             })
             .catch(error => {
               this.ApiUserSupplier = []
               alert(error.response.data.message)
             }),
         axios.post(this.api_tool_url + '/get_oppoint_P', {}, this.config)
         .then(response => {
             this.oppoint = response.data.ResultRows
             this.oppoint.push({ OpPoint_id: '', OpPoint_Description: '-Todos' })
         })
         .catch(error => {
           this.oppoint = []
           alert(error.response.data.message)
         }),

         axios.post(this.api_tool_url + '/get_turningstoragearea2', {}, this.config)
         .then(response => {
             this.TurningStorageArea = response.data.ResultRows
             this.TurningStorageArea.push({ TurningStorageArea_id: '', TurningStorageArea_Desc: '-Todos' })
             this.overlay = false
         })
         .catch(error => {
           this.TurningStorageArea = []
           alert(error.response.data.message)
         })
        },
		
        submit() {
          console.log('Buscando...')
          this.btn = true
          this.dialog_new = true
          this.e1 = 1
          this.progressBar = true
          this.step_error1 = true
          this.step_error2 = true
          this.step_error3 = true
          this.step_color1 = "primary",
          this.step_color2 = "primary",
          this.step_color3 = "primary",
          this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
          let filter = null
          filter = { start_dt: this.editedItem.start_dt, end_dt: this.editedItem.end_dt, ApiPunto: this.editedItem.ApiPunto, TurningStorageArea: this.editedItem.TurningStorageArea, Supplier:this.ApiUserSupplier, RequestProposal_Dt:"" }

          axios.post(this.api_tool_url + '/get_planning',filter, this.config)
          .then(response => {
            // console.log(response)
            if (response.data.ResultRows.length > 0) {
                this.mvm = response.data.ResultRows
                this.e1 = 2
                this.step_color1 = "#008000"
                this.msj_proceso = "Turnos cargados."
                if (this.dialog_new) { 
                  setTimeout(() => (this.dialog_new = false), 4000)
                }
              }
              else {
                this.progressBar = false
                this.msj_proceso = "No se encontraron turnos."
                this.step_error1 = false
                this.step_error2 = false
                this.step_error3 = false
              }
              this.btn = false
          }) 
            .catch(error => {
            this.mvm = []
            this.btn = false
            this.step_error1 = false
            this.progressBar = false
            this.msj_proceso = error.response.data.message
            })
        },

        close() {
          this.dialog_new = false
        },
        close2() {
          this.dialog_detail = false
        },
        deleteTurn() {
        this.dialog1 = false
        let turnos = []
        this.overlay = true
          this.selected.map(sel => { 
            let filterdel = {
                filterborrado : {RequestProposal_id: sel.RequestProposal_id, VendorPurchaseOrder_Num: sel.VendorPurchaseOrder_Num},
                ApiUser_EMail: this.$store.state.ApiUser_EMail,
                ApiUser_Id: this.$store.state.ApiUser_id,
                ApiKey_id: sessionStorage.getItem('access_token')
            }

            turnos.push(filterdel)
          })

          console.log(turnos)
        // -------- Prueba ()Dev --------
        // turnos = [
        //   {
        //   filterborrado : {RequestProposal_id: 5209517, VendorPurchaseOrder_Num: '00109352'},
        //   ApiUser_EMail: this.$store.state.ApiUser_EMail,
        //   ApiUser_Id: this.$store.state.ApiUser_id
        //   },
        //   {
        //   filterborrado : {RequestProposal_id: 5209518, VendorPurchaseOrder_Num: '00109353'},
        //   ApiUser_EMail: this.$store.state.ApiUser_EMail,
        //   ApiUser_Id: this.$store.state.ApiUser_id
        //   }
        // ]
        // console.log('Enviando turnos a eliminar...')
        // console.log('turnos', turnos)
         // ---------del_turno----------
        axios.post(this.api_tool_url + '/del_turno_masivo',turnos , this.config)
            .then(response => {
              // console.log(response)
              if (response.data.ResultRows.length >= 1){
                this.overlay = false
                alert("Se borraron los turnos.")
                this.selected = []
                this.submit()
              }else if (response.data.ResultRows.length > 0){
                this.overlay = false
                alert("Se borro el turno.")
                this.selected = []
                this.submit()
              }else{
                this.overlay = false
                this.selected = []
                alert("No se pudo borrar el/los turno/s.")
              }
        })
        .catch(error => {
          this.overlay = false
          let errorMessage = error.response 
                            && error.response.data 
                            && error.response.data.message 
                            ? error.response.data.message
                            : error.toString()
          alert(errorMessage)
        })
        }
      }
    }
</script>
<style>
    /* Este estilado aplica en todas las pantallas. En caso que no se tenga que aplicar en alguna pantalla al lado de style hay que agregarle scoped para que aplique sólo en este script. */
    #grillaPlanning th {
    white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/PlanningProvDeleteGrid.vue